module.exports = __webpack_public_path__ + "img/system43-mini.58763f26.png";